/**
 * Created by Caroline on 2019/11/25 0025.
 *
 */
import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'
// import modules from './modules'

Vue.use(Vuex)

let env = process.env.NODE_ENV

const host = {
  wl: 'https://live.marryou520.com/api',
  ws: 'wss://live.marryou520.com/api/ws',
}
if(env === 'stg'){
  host.wl = '/weddinglive'
  host.ws = 'ws://staging.live.xitaoinfo.com/weddinglive/ws'
}
if(env === 'dev'){
  host.wl = '/weddinglive'
  host.ws = 'ws://localhost:8085/weddinglive/ws'
}

// const debug = process.env.NODE_ENV !== 'production'
// const isDev = process.env.NODE_ENV === 'dev'
// let hostName = location.hostname
// let origin = location.origin
// let shareHost
// if (!isDev) {
//   shareHost = contextPath && contextPath !== '' ? origin + contextPath : 'https://' + hostName
// }

// console.log("origin", origin);
// console.log("hostName", hostName);
console.log("host", host);
const winWidth = window.innerWidth
const winHeight = window.innerHeight

const state = {
  host: host,
  reqVersion: 'v=1.2.0',

  win: {
    winWidth: winWidth,
    winHeight: winHeight,
    screenWScale: winWidth < 1920 ? parseFloat((Math.floor(winWidth / 1920 * 88)/100) .toFixed(2)) : 1,
    screenHScale: winHeight < 1080 ? parseFloat((Math.floor(winHeight / 1080 * 88)/100) .toFixed(2)) : 1,
  },

  activityId: 0,
  modeData: null,
  tagIds: [],
  detail: {
    activity: {
      title: '',
    },
    qrcodeUrl: '',
  },
  shareData: {
    qrcodeUrl: '',

  },

  imageList: [],

  newBlessing: null,
  blessingList: [],
  blessingData: {
    qrcodeUrl: '',
    total: 0,
  },

  lottery: {},
  lotteryWinners: [],

  headDefault: 'https://image-weddinglive.marryou520.com/miniProgram/logo_wedding_live_v2.png',

  toast: {
    show: false,
    content: '网络状态不好',
  },
  globalFont: {
    size: 'fs-x',
    bold: false
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js